import {
  convert,
  newDate,
  getFields,
  score,
  extractKeys,
  strIndex
} from '@/sui/data/flatten/tools'

import {
  patientAge,
  patientDays,
  findSurveillance,
  initializeSurveillance,
  origin,
  addBacteremia,
  ktDuration,
  unitType
} from '@/sui/data/flatten/common'

function addKT (prefix, target, parent, kt) {
  const config = [
    { key: 'type', get: c => c.type },
    { key: 'insertion', get: c => newDate(c.insertion) },
    { key: 'removed', get: c => c.removed },
    { key: 'removal', get: c => newDate(c.removal) },
    { key: 'duration', get: c => ktDuration(parent, c) }
  ]
  if (kt.type === 1) {
    target.kt_has_cvc = true
  } else if (kt.type === 6) {
    target.kt_has_other = true
  }
  getFields(config, prefix, target, kt)
}

function initializePatient (p, s, y) {
  const result = {
    type: 'reaBactADI',
    surv_id: p.sv
  }

  initializeSurveillance(result, s)

  result.sheet_id = p.id
  result.v = p.v
  result.st = p.st
  result.unit_type = unitType(s.year, p.f.unitType)
  result.uf = p.f.uf
  result.sheet_number = p.f.sheetNumber
  result.birthdate = newDate(p.f.birthdate)
  result.age_years = patientAge(p.f, y)
  result.age_days = patientDays(p.f, y)
  result.sex = p.f.sex
  result.entry = newDate(p.f.entry)
  result.origin = origin(p.f.origin)
  result.trauma = p.f.trauma
  result.diagnosis = p.f.diagnosis
  result.immuno = p.f.immuno
  result.antibio = p.f.antibio
  result.igsII = score('igsII', p.f.mainSeverity)
  result.cribII = score('cribII', p.f.mainSeverity)
  result.pimII = score('pimII', p.f.mainSeverity)
  result.other_score_name = p.f.otherSeverity.code
  result.other_score_value = p.f.otherSeverity.value
  result.mix_managment = p.f.mixManagment
  result.birth_weight = p.f.birthWeight
  result.gestational_age = p.f.gestationalAge
  result.dead = p.f.dead
  result.death = newDate(p.f.death)
  result.exit = newDate(p.f.exit)
  result.kt_count = p.f.catheters.length
  result.kt_has_cvc = false
  result.kt_has_other = false
  result.bact_count = p.f.bacteremias.length

  return result
}

const reducer = (result, p) => {
  const s = findSurveillance(result, p)
  if (s != null && result.p.onlyClosed && s.status !== 'closed') {
    --result.r.length
    return result
  }

  const patient = initializePatient(p, s, 2019)
  if (result.keys == null) {
    result.keys = Object.keys(patient)
  }
  p.f.catheters.forEach(
    (c, i) => addKT(`kt${strIndex(i + 1)}`, patient, p.f, c)
  )
  p.f.bacteremias.forEach(
    (b, i) => addBacteremia(`bact${strIndex(i + 1)}`, patient, p.f, b)
  )

  extractKeys(result, patient, ['kt', 'bact'])
  result.r[result.i++] = patient
  return result
}

export default {
  '2019': function (params) {
    return convert(params, reducer, ['kt', 'bact'])
  }
}
